import { render, staticRenderFns } from "./ResourceMove.vue?vue&type=template&id=3b147853&scoped=true&"
import script from "./ResourceMove.vue?vue&type=script&lang=js&"
export * from "./ResourceMove.vue?vue&type=script&lang=js&"
import style0 from "./ResourceMove.vue?vue&type=style&index=0&id=3b147853&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b147853",
  null
  
)

export default component.exports